/* ============================================================
   Quelton — interacción del tema (sobre Dawn)
   Cabecera · buscador predictivo · tarjeta con compra rápida · cesta (Ajax de Shopify)
   · carruseles · vídeos UGC · buscador de talla · animaciones
   Los datos de cada producto los pinta Liquid en <script type="application/json" data-q-product>.
   ============================================================ */
(function () {
  'use strict';

  const CFG = window.QTHEME || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---------- utilidades ----------
  const img = (url, w) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${w}` : '');
  // precios sin ,00 cuando son redondos (79 €); con decimales solo si los tiene (39,50 €)
  const money = (n) => { const v = Number(n); const whole = Math.abs(v - Math.round(v)) < 0.005; return v.toLocaleString(CFG.locale || 'es-ES', { style: 'currency', currency: CFG.currency || 'EUR', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }); };
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const t = (key, fallback) => (CFG.strings && CFG.strings[key]) || fallback;
  const SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  const sortValues = (a, b) => {
    const ia = SIZE_ORDER.indexOf(String(a).toUpperCase()), ib = SIZE_ORDER.indexOf(String(b).toUpperCase());
    if (ia > -1 && ib > -1) return ia - ib;
    if (ia > -1) return -1;
    if (ib > -1) return 1;
    return String(a).localeCompare(String(b), 'es');
  };

  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = msg;
    el.classList.add('is-open');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => el.classList.remove('is-open'), 2600);
  }

  // ---------- datos de producto (los escribe Liquid) ----------
  const DATA = { products: {} };
  function registerProducts(root = document) {
    $$('script[type="application/json"][data-q-product]', root).forEach((s) => {
      try { const p = JSON.parse(s.textContent); if (!DATA.products[p.handle]) DATA.products[p.handle] = p; } catch (e) { /* JSON roto: se ignora */ }
    });
  }
  registerProducts();

  // talla guardada con el buscador de talla (se usa para "Solo mi talla" y para preseleccionar)
  const Size = {
    get() { try { return JSON.parse(localStorage.getItem('quelton-size')) || null; } catch { return null; } },
    set(v) { try { localStorage.setItem('quelton-size', JSON.stringify(v)); } catch {} document.dispatchEvent(new CustomEvent('quelton:size', { detail: v })); },
  };

  // ---------- producto: opciones normalizadas ----------
  // Los bikinis completos son bundles con opciones como "Top (Talla)", "Braguita (Talla)" y "Braguita (Estilo)".
  function optionMeta(name) {
    const n = name.toLowerCase();
    const part = /top/.test(n) ? 'top' : /braguita|bottom/.test(n) ? 'bottom' : 'single';
    const kind = /estilo|forma|variante|style/.test(n) ? 'style' : /title|denominaci/.test(n) ? 'none' : 'size';
    const labels = {
      'top-size': t('top_size', 'Talla del top'), 'bottom-size': t('bottom_size', 'Talla de la braguita'), 'bottom-style': t('bottom_style', 'Braguita'),
      'single-size': t('size', 'Talla'), 'single-style': t('style', 'Estilo'), 'top-style': t('top_style', 'Estilo del top'),
    };
    const order = { 'top-size': 0, 'bottom-size': 1, 'bottom-style': 2, 'single-size': 0, 'single-style': 1, 'top-style': 1 };
    const key = `${part}-${kind}`;
    return { part, kind, key, label: labels[key] || name, order: order[key] ?? 5 };
  }

  function getProduct(handle) {
    const p = DATA.products[handle];
    if (!p) return null;
    if (p._parsed) return p;
    p.options = p.opt.map((name, i) => ({ name, index: i, ...optionMeta(name) })).filter((o) => o.kind !== 'none');
    p.options.forEach((o) => { o.values = [...new Set(p.v.map((v) => v[1][o.index]).filter(Boolean))].sort(sortValues); });
    p.options.sort((a, b) => a.order - b.order);
    p.price = Math.min(...p.v.map((v) => v[2]));
    p.compare = Math.max(0, ...p.v.map((v) => v[3]));
    p.available = p.v.some((v) => v[4]);
    p.isBundle = p.options.some((o) => o.part === 'top') && p.options.some((o) => o.part === 'bottom');
    p._parsed = true;
    return p;
  }
  function findVariant(p, sel) {
    return p.v.find((v) => p.options.every((o) => sel[o.index] === undefined || v[1][o.index] === sel[o.index]));
  }
  function valueAvailable(p, sel, opt, value) {
    const test = { ...sel, [opt.index]: value };
    return p.v.some((v) => v[4] && p.options.every((o) => test[o.index] === undefined || v[1][o.index] === test[o.index]));
  }
  function prefillSizes(p, sel) {
    const mine = Size.get();
    if (!mine) return;
    p.options.filter((o) => o.kind === 'size').forEach((o) => {
      const want = o.part === 'bottom' || p.k === 'braguita' ? mine.bottom : mine.top;
      if (sel[o.index] === undefined && want && o.values.includes(want) && valueAvailable(p, sel, o, want)) sel[o.index] = want;
    });
  }

  // ---------- capas: cesta, buscador ----------
  function toggleLayer(sel, open) {
    const el = $(sel);
    const overlay = $('[data-overlay]');
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', String(!open));
    overlay && overlay.classList.toggle('is-open', open);
    document.body.classList.toggle('is-locked', open);
    if (!open) $$('[data-cart],[data-search]').forEach((x) => { x.classList.remove('is-open'); x.setAttribute('aria-hidden', 'true'); });
  }

  // ---------- cabecera ----------
  const header = $('[data-header]');
  const hasHero = document.body.classList.contains('has-hero');
  const onScrollHeader = () => header && hasHero && header.classList.toggle('is-solid', window.scrollY > 40);
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  $$('[data-mega]').forEach((btn) => {
    const panel = document.getElementById(btn.dataset.mega);
    const li = btn.closest('li');
    let timer;
    const open = () => { clearTimeout(timer); panel.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); header.classList.add('is-open'); };
    const close = () => { timer = setTimeout(() => { panel.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); header.classList.remove('is-open'); }, 120); };
    btn.addEventListener('click', () => (panel.classList.contains('is-open') ? close() : open()));
    [li, panel].forEach((el) => { el.addEventListener('mouseenter', open); el.addEventListener('mouseleave', close); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  });
  $$('[data-dd]').forEach((btn) => {
    const li = btn.closest('li');
    let tm;
    const set = (open) => { clearTimeout(tm); li.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open)); };
    btn.addEventListener('click', () => set(!li.classList.contains('is-open')));
    li.addEventListener('mouseenter', () => set(true));
    li.addEventListener('mouseleave', () => { tm = setTimeout(() => set(false), 120); });
  });

  const navToggle = $('[data-nav-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => {
      const open = navToggle.getAttribute('aria-expanded') !== 'true';
      navToggle.setAttribute('aria-expanded', String(open));
      mobileNav.classList.toggle('is-open', open);
      header.classList.toggle('is-open', open);
      document.body.classList.toggle('is-locked', open);
    });
  }

  // barra de anuncios
  const bar = $('[data-announcement]');
  if (bar) {
    const items = $$('.announcement__item', bar);
    let i = 0;
    if (items.length > 1) setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, Number(bar.dataset.speed || 4) * 1000);
  }

  // texto que se escribe solo en el buscador: Buscar, Explorar, Descubrir
  const typed = $('[data-typed]');
  if (typed) {
    const words = (typed.dataset.words || 'Buscar,Explorar,Descubrir').split(',').map((w) => w.trim()).filter(Boolean);
    if (reduceMotion) typed.textContent = words[0];
    else {
      let w = 0, c = 0, deleting = false;
      const tick = () => {
        const word = words[w];
        c += deleting ? -1 : 1;
        typed.textContent = word.slice(0, c);
        let delay = deleting ? 55 : 95;
        if (!deleting && c === word.length) { deleting = true; delay = 1600; }
        else if (deleting && c === 0) { deleting = false; w = (w + 1) % words.length; delay = 350; }
        setTimeout(tick, delay);
      };
      tick();
    }
  }

  // ---------- tarjeta de producto: flechas, segunda foto y puntos ----------
  const cardIndex = (track) => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  const cardGo = (track, i) => {
    const n = track.children.length;
    track.scrollTo({ left: ((i + n) % n) * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
  };
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('[data-card-dir]');
    if (!arrow) return;
    e.preventDefault();
    const track = $('[data-card-track]', arrow.closest('.pcard'));
    cardGo(track, cardIndex(track) + Number(arrow.dataset.cardDir));
  });
  document.addEventListener('scroll', (e) => {
    const tr = e.target;
    if (!(tr instanceof Element) || !tr.matches('[data-card-track]')) return;
    const i = cardIndex(tr);
    $$('.pcard__dots span', tr.closest('.pcard')).forEach((d, k) => d.classList.toggle('is-active', k === i));
  }, true);
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest && e.target.closest('.pcard');
      if (!card || card.dataset.hover) return;
      card.dataset.hover = '1';
      const track = $('[data-card-track]', card);
      if (track && track.children.length > 1 && cardIndex(track) === 0) cardGo(track, 1);
      card.addEventListener('mouseleave', function leave() {
        delete card.dataset.hover;
        if (!card.classList.contains('is-qa') && track) cardGo(track, 0);
        card.removeEventListener('mouseleave', leave);
      });
    });
  }

  // ---------- compra rápida (panel flotante en la tarjeta) ----------
  function renderQuickAdd(card) {
    const p = getProduct(card.dataset.card);
    const box = $('[data-qa]', card);
    const sel = card._sel || (card._sel = {});
    p.options.forEach((o) => { if (o.values.length === 1) sel[o.index] = o.values[0]; });
    if (!card._prefilled) { prefillSizes(p, sel); card._prefilled = true; }
    const groups = p.options.map((o) => `
      <div class="qa__group">
        <div class="qa__label"><span>${esc(o.label)}</span><b>${sel[o.index] ? esc(sel[o.index]) : ''}</b></div>
        <div class="chips">${o.values.map((v) => `<button class="chip" type="button" data-opt="${o.index}" data-val="${esc(v)}" aria-pressed="${sel[o.index] === v}" ${valueAvailable(p, sel, o, v) ? '' : 'disabled'}>${esc(v)}</button>`).join('')}</div>
      </div>`).join('');
    const complete = p.options.every((o) => sel[o.index] !== undefined);
    const variant = complete && findVariant(p, sel);
    const can = variant && variant[4];
    box.innerHTML = `
      <div class="qa__head"><span>${p.isBundle ? t('qa_bundle', 'Elige talla de top y de braguita') : t('qa_single', 'Elige tu talla')}</span>
        <button class="qa__close" type="button" data-qa-close aria-label="${t('close', 'Cerrar')}"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>
      </div>
      ${groups}
      <button class="btn btn--dark btn--block qa__add" type="button" data-qa-add ${can || !p.options.length ? '' : 'disabled'}>
        ${complete || !p.options.length ? `${t('add_to_cart', 'Añadir a la cesta')} · ${money(variant ? variant[2] : p.price)}` : (p.options.length > 1 ? t('choose_sizes', 'Elige tus tallas') : t('choose_size', 'Elige tu talla'))}
      </button>`;
  }
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-qa-open]');
    if (openBtn) {
      const card = openBtn.closest('.pcard');
      $$('.pcard.is-qa').forEach((c) => c !== card && c.classList.remove('is-qa'));
      renderQuickAdd(card);
      card.classList.add('is-qa');
      return;
    }
    if (e.target.closest('[data-qa-close]')) { e.target.closest('.pcard').classList.remove('is-qa'); return; }
    const chip = e.target.closest('.qa .chip');
    if (chip) {
      const card = chip.closest('.pcard');
      const idx = Number(chip.dataset.opt);
      card._sel[idx] = card._sel[idx] === chip.dataset.val ? undefined : chip.dataset.val;
      renderQuickAdd(card);
      return;
    }
    const add = e.target.closest('[data-qa-add]');
    if (add) {
      const card = add.closest('.pcard');
      const p = getProduct(card.dataset.card);
      const variant = p.options.length ? findVariant(p, card._sel || {}) : p.v[0];
      if (!variant || !variant[4]) return;
      add.disabled = true;
      Cart.add(variant[0]).finally(() => { card.classList.remove('is-qa'); card._sel = {}; card._prefilled = false; });
    }
  });
  document.addEventListener('click', (e) => {
    if (!e.target.isConnected || e.target.closest('.pcard')) return;
    $$('.pcard.is-qa').forEach((c) => c.classList.remove('is-qa'));
  });

  // ---------- carruseles (pestañas pintadas por Liquid) ----------
  function railProgress(rail, barEl) {
    if (!barEl) return;
    const max = rail.scrollWidth - rail.clientWidth;
    const visible = rail.clientWidth / Math.max(rail.scrollWidth, 1);
    barEl.style.width = `${Math.max(visible, 0.1) * 100}%`;
    barEl.style.left = `${max > 0 ? (rail.scrollLeft / max) * (1 - visible) * 100 : 0}%`;
  }
  $$('[data-rail-section]').forEach((section) => {
    const barEl = $('[data-rail-progress]', section);
    const active = () => $$('[data-rail]', section).find((r) => !r.hidden) || $('[data-rail]', section);
    $$('[data-rail]', section).forEach((rail) => rail.addEventListener('scroll', () => railProgress(rail, barEl), { passive: true }));
    window.addEventListener('resize', () => railProgress(active(), barEl));
    requestAnimationFrame(() => railProgress(active(), barEl));
    $('[data-rail-prev]', section)?.addEventListener('click', () => active().scrollBy({ left: -active().clientWidth * 0.8 }));
    $('[data-rail-next]', section)?.addEventListener('click', () => active().scrollBy({ left: active().clientWidth * 0.8 }));
    $$('[data-tab]', section).forEach((tab) => tab.addEventListener('click', () => {
      $$('[data-tab]', section).forEach((x) => x.setAttribute('aria-selected', String(x === tab)));
      $$('[data-rail]', section).forEach((r) => (r.hidden = r.dataset.rail !== tab.dataset.tab));
      const r = active();
      r.scrollLeft = 0;
      if (r.animate && !reduceMotion) r.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.16,1,.3,1)' });
      requestAnimationFrame(() => railProgress(r, barEl));
    }));
  });
  $$('[data-scroll-prev],[data-scroll-next]').forEach((btn) => {
    const target = document.getElementById(btn.dataset.scrollPrev || btn.dataset.scrollNext);
    const dir = btn.dataset.scrollPrev ? -1 : 1;
    btn.addEventListener('click', () => target && target.scrollBy({ left: dir * target.clientWidth * 0.8 }));
  });

  // ---------- cesta: Ajax de Shopify ----------
  const root = (CFG.routes && CFG.routes.root) || '/';
  const Cart = {
    data: null,
    async fetch() { this.data = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json(); this.render(); return this.data; },
    async add(id, quantity = 1) {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) });
      const json = await res.json();
      if (!res.ok) { toast(esc(json.description || json.message || t('cart_error', 'No se ha podido añadir'))); return null; }
      await this.fetch();
      this.open();
      document.dispatchEvent(new CustomEvent('quelton:cart', { detail: this.data }));
      return json;
    },
    async change(key, quantity) {
      const res = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      this.data = await res.json();
      this.render();
    },
    render() {
      const c = this.data;
      if (!c) return;
      $$('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.dataset.count = c.item_count; });
      $$('[data-cart-count-text]').forEach((el) => (el.textContent = c.item_count ? `(${c.item_count})` : ''));
      const body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
      if (!body) return;
      if (!c.item_count) {
        body.innerHTML = `<div class="drawer__empty"><span class="script">${t('cart_empty_script', 'Vaya…')}</span><p>${t('cart_empty', 'Tu cesta está vacía.')}</p><a class="btn btn--dark" href="${CFG.routes.all_products || '/collections/all'}">${t('see_new', 'Ver novedades')}</a></div>`;
        foot.innerHTML = '';
        return;
      }
      body.innerHTML = c.items.map((i) => `
        <div class="line">
          <a href="${i.url}"><img src="${img(i.image, 200)}" alt=""></a>
          <div>
            <p class="line__title"><a href="${i.url}">${esc(i.product_title)}</a></p>
            <p class="line__opts">${(i.options_with_values || []).filter((o) => o.value !== 'Default Title').map((o) => `${esc(o.name)}: ${esc(o.value)}`).join(' · ')}</p>
            <div class="qty"><button type="button" data-qty="${i.key}" data-n="${i.quantity - 1}" aria-label="${t('minus', 'Quitar uno')}">−</button><span>${i.quantity}</span><button type="button" data-qty="${i.key}" data-n="${i.quantity + 1}" aria-label="${t('plus', 'Añadir uno')}">+</button></div>
          </div>
          <div class="line__right"><span>${money(i.final_line_price / 100)}</span><button class="line__remove" type="button" data-qty="${i.key}" data-n="0">${t('remove', 'Quitar')}</button></div>
        </div>`).join('') + '<div data-upsell></div>';
      const free = Number(CFG.freeShipping || 0);
      const total = c.total_price / 100;
      const ship = free ? (() => {
        const left = free - total;
        const pct = Math.min(100, (total / free) * 100);
        return `<div class="ship-bar"><p>${left > 0 ? `${t('ship_left', 'Te faltan')} <b>${money(left)}</b> ${t('ship_left_2', 'para el envío gratis')}` : t('ship_free', '¡Tienes <b>envío gratis</b>!')}</p><div><span style="width:${pct}%"></span></div></div>`;
      })() : '';
      foot.innerHTML = `${ship}
        <div class="drawer__row"><span>${t('subtotal', 'Subtotal')}</span><span>${money(total)}</span></div>
        <p class="drawer__note">${t('taxes', 'Impuestos incluidos. Los gastos de envío se calculan al finalizar la compra.')}</p>
        <form action="${CFG.routes.cart || '/cart'}" method="post"><button class="btn btn--dark btn--lg btn--block" type="submit" name="checkout">${t('checkout', 'Finalizar compra')}</button></form>
        ${(CFG.payLogos || []).length ? `<div class="pay-secure" style="justify-content:center;margin-top:14px"><span class="pay-secure__label">${esc(t('secure_payment', 'Pago seguro'))}</span><ul class="pay-logos" aria-label="${esc(t('payments', 'Métodos de pago'))}">${CFG.payLogos.map((l) => `<li><img class="pay-logos__${esc(l.key)}" src="${l.src}" alt="${esc(l.key)}" loading="lazy" height="16"></li>`).join('')}</ul>` : `<p class="drawer__note">${t('payments', 'Paga con tarjeta, Apple Pay, PayPal, Bizum o en 3 plazos con Klarna.')}</p>`}`;
      this.upsell();
    },
    // Recomendaciones en la cesta (reglas de Quelton, snippet q-cart-rules):
    //  - top sin su braguita → la braguita a juego · braguita sin top → su top (triángulo antes que sporty)
    //  - bikini completo → otros bikinis completos (más vendidos primero)
    //  - si no hay regla para el producto → recomendaciones de Shopify (Search & Discovery)
    // Cada sugerencia lleva un "+": si el producto tiene tallas, se despliegan aquí mismo para elegirlas.
    async upsell() {
      const box = $('[data-upsell]');
      const c = this.data;
      if (!box || !c.items.length) return;
      let rules = { pairs: {}, bikinis: [] };
      try { rules = JSON.parse($('#q-cart-rules')?.textContent || '{}'); } catch {}
      const inCart = new Set(c.items.map((i) => i.handle));
      const want = [];
      let title = t('complete_look', 'Completa el look');
      const last = c.items[0]; // el último añadido sale el primero en la cesta de Shopify
      for (const it of c.items) {
        const partners = (rules.pairs || {})[it.handle];
        if (partners && !partners.some((h) => inCart.has(h))) {
          partners.forEach((h) => want.push(h));
          if (it === last || want.length === partners.length) title = /^braguita|^bottom/i.test(partners[0]) ? t('missing_bottom', 'Te falta la braguita a juego') : t('missing_top', 'Te falta el top a juego');
          break;
        }
      }
      if (!want.length && c.items.some((i) => (rules.bikinis || []).includes(i.handle))) {
        (rules.bikinis || []).filter((h) => !inCart.has(h)).slice(0, 3).forEach((h) => want.push(h));
        title = t('more_bikinis', 'Otros bikinis que te pueden gustar');
      }
      let products = [];
      try {
        if (want.length) {
          products = (await Promise.all(want.slice(0, 3).map((h) => fetch(`${root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))).filter((p) => p && p.available);
        } else {
          const res = await fetch(`${root}recommendations/products.json?product_id=${last.product_id}&intent=complementary&limit=4`);
          products = ((await res.json()).products || []).filter((r) => r.available && !inCart.has(r.handle)).slice(0, 3);
        }
      } catch (e) { products = []; }
      if (!products.length) { box.innerHTML = ''; return; }
      this.recs = products;
      box.innerHTML = `<div class="upsell"><h3>${esc(title)}</h3>${products.map((p, i) => `
        <div class="upsell__card" data-rec="${i}">
          <a href="${p.url}" class="upsell__img"><img src="${img(p.featured_image, 200)}" alt="" width="60" height="75"></a>
          <div class="upsell__info"><a href="${p.url}">${esc(p.title)}</a><b>${money(p.price / 100)}</b></div>
          <button class="upsell__plus" type="button" data-rec-plus="${i}" aria-label="${esc(t('add_to_cart', 'Añadir a la cesta'))}: ${esc(p.title)}">+</button>
          <div class="upsell__opts" data-rec-opts hidden></div>
        </div>`).join('')}</div>`;
    },
    recOptions(i) {
      const p = this.recs[i];
      const card = $(`[data-rec="${i}"]`);
      const saved = Size.get() || {};
      const opts = p.options.map((o, oi) => {
        const n = (o.name || '').toLowerCase();
        const pref = /braguita|bottom/.test(n) && /talla|size/.test(n) ? saved.bottom : /talla|size/.test(n) ? saved.top : null;
        return `<label><span>${esc(o.name)}</span><select data-rec-opt="${oi}">${o.values.map((v) => `<option${v === pref ? ' selected' : ''}>${esc(v)}</option>`).join('')}</select></label>`;
      }).join('');
      const box = $('[data-rec-opts]', card);
      box.innerHTML = `${opts}<button class="btn btn--dark btn--block" type="button" data-rec-add="${i}">${esc(t('add_to_cart', 'Añadir a la cesta'))}</button>`;
      box.hidden = false;
    },
    async recAdd(i) {
      const p = this.recs[i];
      const card = $(`[data-rec="${i}"]`);
      const chosen = $$('[data-rec-opt]', card).map((s) => s.value);
      const v = p.variants.find((x) => chosen.every((val, k) => x.options[k] === val));
      if (!v || !v.available) { toast(esc(t('quiz_sold_out', 'está agotado en esta talla.'))); return; }
      await this.add(v.id, 1);
    },
    open() { toggleLayer('[data-cart]', true); },
  };
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); Cart.open(); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', () => toggleLayer('[data-cart]', false)));
  $('[data-overlay]')?.addEventListener('click', () => toggleLayer('[data-cart]', false));
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty]');
    if (q) Cart.change(q.dataset.qty, Number(q.dataset.n));
    const plus = e.target.closest('[data-rec-plus]');
    if (plus) {
      const p = Cart.recs && Cart.recs[Number(plus.dataset.recPlus)];
      if (p && p.variants.length === 1) Cart.add(p.variants[0].id, 1); else Cart.recOptions(Number(plus.dataset.recPlus));
    }
    const radd = e.target.closest('[data-rec-add]');
    if (radd) Cart.recAdd(Number(radd.dataset.recAdd));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { toggleLayer('[data-cart]', false); closeQuiz(); } });
  if ($('[data-cart]')) Cart.fetch();

  // ---------- buscador predictivo de Shopify ----------
  const search = $('[data-search]');
  const searchInput = $('[data-search-input]');
  const results = $('[data-search-results]');
  let searchTimer;
  async function runSearch(q) {
    const term = q.trim();
    if (!term) { results.innerHTML = ''; return; }
    try {
      const url = `${(CFG.routes && CFG.routes.predictive_search) || '/search/suggest'}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=10`;
      const products = (await (await fetch(url)).json()).resources.results.products || [];
      results.innerHTML = products.length
        ? products.map((p) => `<a href="${p.url}"><img src="${img(p.image || p.featured_image?.url, 400)}" alt="" loading="lazy">${esc(p.title)}<small>${money(Number(p.price))}</small></a>`).join('')
        : `<p class="search-empty">${t('search_none', 'No encontramos nada con')} «${esc(term)}».</p>`;
    } catch (e) { results.innerHTML = ''; }
  }
  function openSearch() {
    if (!search) return;
    search.classList.add('is-open'); search.setAttribute('aria-hidden', 'false');
    $('[data-overlay]')?.classList.add('is-open'); document.body.classList.add('is-locked');
    setTimeout(() => searchInput.focus(), 200);
  }
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', openSearch));
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', () => toggleLayer('[data-search]', false)));
  searchInput?.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => runSearch(searchInput.value), 220); });
  $$('[data-search-suggest] button').forEach((b) => b.addEventListener('click', () => { searchInput.value = b.textContent; runSearch(b.textContent); }));

  // ---------- buscador de talla ----------
  // Tabla en cm: se edita en Ajustes del tema > Guía de tallas (CFG.sizeChart).
  // Por defecto: XS confirmada (78–84 / 60–64 / 86–92); S, M y L PROVISIONALES hasta tener la tabla oficial.
  // tabla oficial (Ajustes del tema > Quelton): límite superior de cada talla en cm
  const CHART = CFG.sizeChart && CFG.sizeChart.length ? CFG.sizeChart : [
    { size: 'XS', pecho: 84, cintura: 64, cadera: 92 },
    { size: 'S', pecho: 89, cintura: 68, cadera: 97 },
    { size: 'M', pecho: 94, cintura: 72, cadera: 102 },
    { size: 'L', pecho: 100, cintura: 78, cadera: 108 },
  ];
  const BRA = { 70: 'XS', 75: 'XS', 80: 'S', 85: 'S', 95: 'M', 100: 'L' };
  const JEANS = { 32: 'XS', 36: 'S', 38: 'M', 40: 'L', 42: 'XL' };
  const quiz = $('[data-quiz]');
  let quizMode = 'medidas';
  const touched = new Set();
  if (quiz) {
    let from = { pecho: 78, cintura: 60, cadera: 86 };
    $('[data-size-rows]', quiz).innerHTML = CHART.filter((r) => r.pecho < 999).map((r) => {
      const row = `<tr data-row="${r.size}"><td>${r.size}</td><td>${from.pecho} – ${r.pecho}</td><td>${from.cintura} – ${r.cintura}</td><td>${from.cadera} – ${r.cadera}</td></tr>`;
      from = { pecho: r.pecho, cintura: r.cintura, cadera: r.cadera };
      return row;
    }).join('');
  }
  function showSlider(k) {
    const input = $(`[data-q="${k}"]`, quiz);
    $(`[data-out="${k}"]`, quiz).textContent = touched.has(k) ? `${input.value} cm` : '— cm';
  }
  function calcQuiz() {
    let top, bottom;
    if (quizMode === 'ropa') {
      const bra = $('[data-q="bra"]', quiz).value, jeans = $('[data-q="jeans"]', quiz).value;
      if (!bra || !jeans) { toast(t('quiz_choose', 'Elige tu talla de sujetador y de vaquero')); return; }
      top = BRA[bra]; bottom = JEANS[jeans];
    } else {
      const v = (k) => Number($(`[data-q="${k}"]`, quiz).value);
      ['pecho', 'cintura', 'cadera'].forEach((k) => { touched.add(k); showSlider(k); });
      // el pecho manda para el top y la cadera para la braguita; en el límite entre dos tallas, la más grande
      const pick = (k) => (CHART.find((r) => v(k) < r[k]) || CHART[CHART.length - 1]).size;
      top = pick('pecho');
      bottom = pick('cadera');
    }
    $('[data-result="top"]', quiz).textContent = top;
    $('[data-result="bottom"]', quiz).textContent = bottom;
    $('.quiz__result', quiz).classList.add('is-done');
    showQuizResult(top, bottom, top === bottom
      ? `${t('quiz_same', 'Te recomendamos la misma talla en las dos piezas:')} ${top}.`
      : `${t('quiz_diff', 'Como vendemos top y braguita por separado, puedes llevar')} ${top} / ${bottom}.`);
  }
  // resultado (desde el cálculo o eligiendo la modelo a la que más se parece)
  function showQuizResult(top, bottom, text) {
    $('[data-result="top"]', quiz).textContent = top;
    $('[data-result="bottom"]', quiz).textContent = bottom;
    $('.quiz__result', quiz).classList.add('is-done');
    const note = $('[data-result-note]', quiz);
    note.hidden = false;
    note.textContent = text;
    $('[data-quiz-save]', quiz).hidden = false;
    quizResult = { top, bottom };
    quizStyle = null;
    renderQuizBuy();
    $$('[data-row]', quiz).forEach((r) => r.classList.toggle('is-match', r.dataset.row === top || r.dataset.row === bottom));
  }
  // ---------- del resultado a la cesta: el producto de la ficha, con las tallas calculadas ----------
  let quizResult = null, quizStyle = null;
  const styleLabel = (v) => (/tanga/i.test(v) ? 'Tanga' : /basic|básic/i.test(v) ? t('basic', 'Básica') : v);
  const STYLE_INFO = {
    'Básica': ['Más cobertura, con la forma clásica', '<svg width="28" height="16" viewBox="0 0 28 16" fill="none" aria-hidden="true"><path d="M2 3h24c-2 6-6 11-12 11S4 9 2 3z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>'],
    'Tanga': ['Menos cobertura, ideal para broncear', '<svg width="28" height="16" viewBox="0 0 28 16" fill="none" aria-hidden="true"><path d="M2 3h24c-4 4-8 6-10 11h-4C10 9 6 7 2 3z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>'],
  };
  const shopMine = () => `${(CFG.routes && CFG.routes.all_products) || '/collections/all'}`;
  function renderQuizBuy() {
    const box = quiz && $('[data-quiz-buy]', quiz);
    if (!box || !quizResult) return;
    const ctx = window.Q && window.Q.quizContext;
    const { top, bottom } = quizResult;
    box.hidden = false;
    if (!ctx) { box.innerHTML = `<a class="btn btn--dark btn--block btn--lg" href="${shopMine()}" data-quiz-shop>${esc(t('quiz_see_mine', 'Ver bikinis en mi talla'))}</a>`; return; }
    const p = ctx.product;
    const s = {};
    const missing = [];
    p.options.forEach((o) => {
      if (o.values.length === 1) { s[o.index] = o.values[0]; return; }
      if (o.kind === 'size') {
        const want = o.part === 'bottom' || p.k === 'braguita' ? bottom : top;
        if (o.values.includes(want)) s[o.index] = want; else missing.push(`${o.label} ${want}`);
      } else s[o.index] = quizStyle || ctx.sel[o.index];
    });
    const more = `<a href="${shopMine()}" data-quiz-shop>${esc(t('quiz_see_mine', 'Ver bikinis en mi talla'))}</a>`;
    if (missing.length) { box.innerHTML = `<p class="quiz__buy-msg">${esc(t('quiz_no_size', 'Este modelo no tiene'))} ${esc(missing.join(' / '))}. ${more}</p>`; return; }
    // braguita básica o tanga: siempre se elige aquí, a la vista, justo antes de añadir (si ya estaba marcada en la ficha, sale marcada)
    const styleOpt = p.options.find((o) => o.kind === 'style' && o.values.length > 1);
    let styleHTML = '';
    if (styleOpt) {
      const chosen = quizStyle || ctx.sel[styleOpt.index];
      s[styleOpt.index] = chosen;
      styleHTML = `<p class="quiz__sub quiz__sub--tight">${esc(t('bottom_style', 'Braguita'))}${chosen ? `: <b>${esc(styleLabel(chosen))}</b>` : ''}</p>
        <div class="quiz__styles">${styleOpt.values.map((v) => {
          const info = STYLE_INFO[styleLabel(v)] || ['', ''];
          return `<button type="button" class="quiz__style" data-quiz-style="${esc(v)}" aria-pressed="${chosen === v}" ${valueAvailable(p, { ...s, [styleOpt.index]: undefined }, styleOpt, v) ? '' : 'disabled'}>${info[1]}<b>${esc(styleLabel(v))}</b><small>${esc(info[0])}</small></button>`;
        }).join('')}</div>`;
      if (!chosen) {
        box.innerHTML = `${styleHTML}<button class="btn btn--dark btn--block btn--lg quiz__add" type="button" disabled><span>${esc(t('quiz_pick', 'Elige braguita básica o tanga'))}</span></button>`;
        return;
      }
    }
    const v = findVariant(p, s);
    const sizes = p.isBundle ? `${t('top_size', 'Top')} ${top} · ${t('bottom_size', 'Braguita')} ${bottom}` : `${t('size', 'Talla')} ${p.k === 'braguita' ? bottom : top}`;
    if (!v || !v[4]) { box.innerHTML = `${styleHTML}<p class="quiz__buy-msg"><b>${esc(sizes)}</b> ${esc(t('quiz_sold_out', 'está agotado en este modelo.'))} ${more}</p>`; return; }
    box.innerHTML = `${styleHTML}<button class="btn btn--dark btn--block btn--lg quiz__add" type="button" data-quiz-add>
        <span>${esc(t('quiz_add', 'Añadir a la cesta'))}</span><small>${esc(sizes)}${styleOpt ? ` · ${esc(styleLabel(s[styleOpt.index]))}` : ''} · ${money(v[2])}</small></button>`;
    box._variant = v; box._sel = s;
  }
  if (quiz) {
    quiz.addEventListener('click', (e) => {
      const mdl = e.target.closest('[data-quiz-model]');
      if (mdl) {
        const sz = mdl.dataset.quizModel;
        $$('[data-quiz-model]', quiz).forEach((b) => b.setAttribute('aria-pressed', String(b === mdl)));
        showQuizResult(sz, sz, `${t('quiz_like', 'Como')} ${mdl.dataset.name}: ${sz}. ${t('quiz_bigger', 'Si dudas entre dos tallas, elige la más grande.')}`);
        $('.quiz__result', quiz)?.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
        return;
      }
      const st = e.target.closest('[data-quiz-style]');
      if (st) { quizStyle = st.dataset.quizStyle; renderQuizBuy(); return; }
      if (e.target.closest('[data-quiz-shop]')) { if (quizResult) Size.set(quizResult); return; }
      if (e.target.closest('[data-quiz-add]')) {
        const box = $('[data-quiz-buy]', quiz);
        const ctx = window.Q.quizContext;
        Size.set(quizResult);
        ctx.apply(box._sel);
        closeQuiz();
        Cart.add(box._variant[0]);
      }
    });
  }
  function openQuiz(e) { e && e.preventDefault(); if (!quiz) return; quiz.classList.add('is-open'); document.body.classList.add('is-locked'); }
  function closeQuiz() { if (!quiz) return; quiz.classList.remove('is-open'); if (!$('.drawer.is-open,.search-panel.is-open')) document.body.classList.remove('is-locked'); }
  document.addEventListener('click', (e) => { if (e.target.closest('[data-quiz-open]')) openQuiz(e); });
  if (quiz) {
    $$('[data-quiz-close]', quiz).forEach((b) => b.addEventListener('click', closeQuiz));
    $$('[data-quiz-mode]', quiz).forEach((b) => b.addEventListener('click', () => {
      quizMode = b.dataset.quizMode;
      $$('[data-quiz-mode]', quiz).forEach((x) => x.setAttribute('aria-selected', String(x === b)));
      $$('[data-quiz-panel]', quiz).forEach((p) => (p.hidden = p.dataset.quizPanel !== quizMode));
    }));
    $$('input[type="range"][data-q]', quiz).forEach((i) => i.addEventListener('input', () => { touched.add(i.dataset.q); showSlider(i.dataset.q); }));
    $('[data-quiz-calc]', quiz).addEventListener('click', calcQuiz);
    $('[data-quiz-save]', quiz).addEventListener('click', () => {
      const v = { top: $('[data-result="top"]', quiz).textContent, bottom: $('[data-result="bottom"]', quiz).textContent };
      Size.set(v);
      closeQuiz();
      toast(`${t('quiz_saved', 'Guardado')}: top <b>${v.top}</b> · ${t('bottom', 'braguita')} <b>${v.bottom}</b>`);
    });
  }

  // ---------- vídeos UGC: se cargan y reproducen solo cuando se ven ----------
  $$('[data-ugc]').forEach((wrap) => {
    if ('IntersectionObserver' in window) {
      const vio = new IntersectionObserver((entries) => entries.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) {
          $$('source[data-src]', v).forEach((s) => { s.src = s.dataset.src; s.removeAttribute('data-src'); v.load(); });
          if (!reduceMotion) v.play().catch(() => {});
        } else v.pause();
      }), { threshold: 0.4 });
      $$('video', wrap).forEach((v) => vio.observe(v));
    }
    wrap.addEventListener('click', (e) => {
      const b = e.target.closest('[data-sound]');
      if (!b) return;
      const v = b.parentElement.querySelector('video');
      const unmute = v.muted;
      $$('video', wrap).forEach((x) => { x.muted = true; x.parentElement.classList.remove('has-sound'); });
      v.muted = !unmute;
      if (unmute) { v.parentElement.classList.add('has-sound'); v.play().catch(() => {}); }
    });
  });

  // ---------- título que cruza la foto al hacer scroll (efecto EME) ----------
  const floats = $$('[data-float-title]');
  if (floats.length && !reduceMotion) {
    let tk = false;
    const run = () => {
      floats.forEach((el) => {
        const box = el.closest('[data-float-box]').getBoundingClientRect();
        if (box.bottom < 0 || box.top > innerHeight) return;
        const prog = Math.min(1, Math.max(0, (innerHeight - box.top) / (innerHeight + box.height)));
        el.style.transform = `translate3d(0, ${((prog - 0.5) * box.height * 0.9).toFixed(1)}px, 0)`;
      });
      tk = false;
    };
    window.addEventListener('scroll', () => { if (!tk) { tk = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  // ---------- parallax suave en la campaña ----------
  const par = $$('[data-parallax]');
  if (par.length && !reduceMotion) {
    let ticking = false;
    const run = () => {
      par.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        const progress = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        el.firstElementChild.style.transform = `translate3d(0, ${(progress * -8).toFixed(2)}%, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  // ---------- aparición al hacer scroll ----------
  function initReveal(scope = document) {
    const items = $$('.reveal:not(.is-visible)', scope);
    if (!('IntersectionObserver' in window) || reduceMotion || window.Shopify?.designMode) { items.forEach((el) => el.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    items.forEach((el) => io.observe(el));
  }
  initReveal();
  // en el editor de Shopify, al añadir o cambiar una sección
  document.addEventListener('shopify:section:load', (e) => { registerProducts(e.target); initReveal(e.target); });

  // ---------- transición suave entre páginas ----------
  if (!reduceMotion && !window.Shopify?.designMode) {
    document.documentElement.classList.add('is-entering');
    requestAnimationFrame(() => requestAnimationFrame(() => document.documentElement.classList.remove('is-entering')));
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank' || a.getAttribute('href').startsWith('#') || !/^https?:/.test(a.href)) return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin || (url.pathname === location.pathname && url.hash) || /\/(checkout|cart|account)/.test(url.pathname)) return;
      e.preventDefault();
      document.documentElement.classList.add('is-leaving');
      setTimeout(() => (location.href = url.href), 220);
    });
    window.addEventListener('pageshow', (e) => { if (e.persisted) document.documentElement.classList.remove('is-leaving'); });
  }

  // ---------- utilidades para la ficha de producto y la colección ----------
  window.Q = { DATA, img, money, esc, toast, t, getProduct, findVariant, valueAvailable, prefillSizes, registerProducts,
    Cart, Size, openQuiz, reduceMotion, sortValues, initReveal };
})();
